import { useMemo } from 'react';
import { customObjValues } from '../formatters';
import { FuneralServiceMediaSource } from '../types';
import { StartingThumbnailVideo } from './Partials/Shared/StartingThumbnailVideo';
import { ThumbnailVideo } from './Partials/Shared/ThumbnailVideo';
import VideoViewer from './Stream/VideoViewer';

const Thumbnails = ({ isLive, playerSources, videos, selectedSource, setSelectedSource }) => {
  return (
    <div className="stream-source-container">
      {isLive ? (
        playerSources && playerSources.length > 0 ? (
          customObjValues(playerSources)
            .sort((a) => (customObjValues(a)[0][0].is_primary ? -1 : 1))
            .map((preSource: FuneralServiceMediaSource, index) => {
              const source = customObjValues(preSource)[0][0];
              return (
                <ThumbnailVideo
                  key={index}
                  source={source}
                  isSelected={selectedSource && source.url === customObjValues(selectedSource)[0][0].url}
                  setSelectedSource={() => setSelectedSource(preSource)}
                />
              );
            })
        ) : (
          <StartingThumbnailVideo isSelected={!selectedSource} setSelectedSource={() => setSelectedSource(undefined)} />
        )
      ) : null}

      {!!videos?.length && videos && (
        <div className="video-thumbnail-container" id="videos-container">
          {isLive ? null : <span className="video-thumbnail-container-title">Videos</span>}
          <div className="flex flex-row gap-4">
            {videos.map((video, index) => (
              <ThumbnailVideo
                key={index}
                source={video.sources[0]}
                isSelected={video.sources[0] === selectedSource}
                setSelectedSource={() => setSelectedSource(video.sources[0])}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const Stream = ({ wasWatching, isLive, eosms, selectedSource, viewerCount, viewerStats, playerSources, videos, setSelectedSource }) => {
  const sourceHash = useMemo(() => {
    if (!selectedSource) return null;
    if (selectedSource.hash) {
      return [selectedSource.hash, 'stream'];
    }

    const video = videos.find((video) => video.sources[0].url === selectedSource.url);
    if (video?.uuid) {
      return [video.uuid, 'video'];
    }

    console.warn('Failed to get sourceHash... maybe prototype.js is installed (it overrides browser defaults 😠)');
    return null;
  }, [JSON.stringify(selectedSource), JSON.stringify(playerSources)]);

  return (
    <>
      {isLive && !selectedSource && !(playerSources.length > 0) ? (
        <div className="fake-video-container">
          <div className="loader-container">
            <div className="loader"></div>
            <div className="loader-message">The stream will start soon...</div>
          </div>
        </div>
      ) : null}

      {selectedSource && ((isLive && playerSources) || videos?.length) ? (
        <VideoViewer
          key={customObjValues(selectedSource)[0][0]?.url}
          source={selectedSource}
          isLive={isLive}
          viewerCount={viewerCount}
          viewerStats={viewerStats}
          sourceHash={sourceHash}
        />
      ) : null}

      {!isLive && wasWatching && (
        <div className="fake-video-container">
          <div className="eosm">{eosms.reduce((f, s) => (new Date(f.display_after) > new Date(s.display_after) ? f : s)).message}</div>
        </div>
      )}

      <Thumbnails
        isLive={isLive}
        videos={videos}
        selectedSource={selectedSource}
        playerSources={playerSources}
        setSelectedSource={setSelectedSource}
      />
    </>
  );
};
